import React from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { DEFAULT_ICON_CLASS_NAME } from '../../../theme/constants/icon';
import useBooleanState from '../../../hooks/useBooleanState';

const CollapsibleSection = ({ title, children, id }) => {
  const [expanded, toggleExpanded] = useBooleanState(true);

  return (
    <Paper
      elevation={0}
      sx={{ border: '1px solid', borderColor: 'gray.A300', borderRadius: 2, p: 2 }}
      id={id}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        onClick={toggleExpanded}
        sx={{ cursor: 'pointer' }}
      >
        <Typography variant="medium_3" fontWeight={600} color="gray.A700">
          {title}
        </Typography>
        <IconButton
          size="small"
          aria-label={`expand-${id}`}
          sx={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        >
          <ExpandMoreIcon className={DEFAULT_ICON_CLASS_NAME} />
        </IconButton>
      </Stack>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Paper>
  );
};

CollapsibleSection.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  id: PropTypes.string,
};

CollapsibleSection.defaultProps = {
  id: undefined,
};

export default CollapsibleSection;
